import React, { useEffect, useState } from "react";
import "../styles/Counter.styles.scss";

interface CounterProps {
  total: number;
  label: string;
}

const Counter = (props: CounterProps) => {
  const { total, label } = props;
  const [totalLocal, setTotalLocal] = useState(0);

  const doFlip = (numberIndex: number = 5) => {
    if (stopTimeout()) return;
    let currentNumberElement = document.getElementsByClassName(`${label}`)[
      numberIndex
    ];

    let currentNumber = Number(
      currentNumberElement.getAttribute("data-number")
    );

    currentNumber++;

    if (currentNumber > 9) {
      currentNumber = 0;
      doFlip(--numberIndex);
    }

    currentNumberElement.classList.add("flip");

    setTimeout(function () {
      currentNumberElement.setAttribute("data-number", `${currentNumber}`);

      currentNumberElement.classList.remove("flip");
    }, 500);

    setTimeout(doFlip, 1);
  };

  const stopTimeout = (): boolean => {
    try {
      let n1 = Number(
        document.getElementsByClassName(`${label}`)[0].getAttribute("data-number")
      );
      let n2 = Number(
        document.getElementsByClassName(`${label}`)[1].getAttribute("data-number")
      );
      let n3 = Number(
        document.getElementsByClassName(`${label}`)[2].getAttribute("data-number")
      );
      let n4 = Number(
        document.getElementsByClassName(`${label}`)[3].getAttribute("data-number")
      );
      let n5 = Number(
        document.getElementsByClassName(`${label}`)[4].getAttribute("data-number")
      );
      let n6 = Number(
        document.getElementsByClassName(`${label}`)[5].getAttribute("data-number")
      );
      let centmil = Math.floor(total / 100000);
      let decmil = Math.floor((total % 100000) / 10000);
      let mil = Math.floor((total % 10000) / 1000);
      let cent = Math.floor((total % 1000) / 100);
      let dec = Math.floor((total % 100) / 10);
      let uni = (total % 100) % 10;

      return n1 === centmil && n2 === decmil && n3 === mil && n4 === cent && n5 === dec && n6 === uni;
    } catch (error) {
      return true
    }
  };

  useEffect(() => {
    if (total && total !== 0) setTimeout(doFlip, 1);
  }, [total]);

  useEffect(() => {
    setTotalLocal(total);
  }, []);

  return (
    <div className="counterWrapper">
      <div style={{marginBottom: "150px"}}>
        <span
          className={`number ${label}`}
          data-number={`${Math.floor(total / 100000)}`}
          style={{display: "none"}}
        >
          <span className="primary"></span>
          <span className="secondary"></span>
        </span>
        <span
          className={`number ${label}`}
          data-number={`${Math.floor((total % 100000) / 10000)}`}
        >
          <span className="primary"></span>
          <span className="secondary"></span>
        </span>

        <span
          className={`number ${label}`}
          data-number={`${Math.floor((total % 10000) / 1000)}`}
        >
          <span className="primary"></span>
          <span className="secondary"></span>
        </span>
        <span
          className={`number ${label}`}
          data-number={`${Math.floor((total % 1000) / 100)}`}
        >
          <span className="primary"></span>
          <span className="secondary"></span>
        </span>
        <span
          className={`number ${label}`}
          data-number={`${total > 9 ? Math.floor((total % 100) / 10) : 0}`}
        >
          <span className="primary"></span>
          <span className="secondary"></span>
        </span>
        <span
          className={`number ${label}`}
          data-number={`${(total % 100) % 10}`}
        >
          <span className="primary"></span>
          <span className="secondary"></span>
        </span>
      </div>
      <div className="titulo">{`${label} ${new Date().getFullYear()}`} </div>
    </div>
  );
};

export default Counter;
